import type { MessageFunction } from 'vue-i18n';
import homepage from './pages/homepage/index';
import tech from './pages/tech/index';
import statistics from './pages/statistics/index';
import Info from './pages/info/index';
import system from './pages/system/index';
// 爱沙尼亚
export default {
    license: {
        powered_by: 'SAIC Motor International {\'|\'} Kõik õigused kaitstud',
    },
    auth: {
        login: 'Logi sisse',
        username: 'Kasutajanimi',
        username_placeholder: 'Sisestage kasutajanimi',
        password: 'Parool',
        password_placeholder: 'Sisestage parool',
        code: 'Kinnituskood',
        code_placeholder: 'Sisestage kinnituskood',
        logout: 'Logi välja',
        logout_success: 'Edukalt välja logitud',
        day: 'päev',
        password_expiration: 'Parool on aegunud – palun värskendage seda',
        expire: 'Päevi jäänud enne parooli aegumist',
        conseils:
            'Peab sisaldama suuri tähti, väikseid tähti, numbreid ja erimärke ({msg}). Parooli pikkus peab olema 8–16 tähemärki.',
        brand_Selection: 'Brändi valik',
        unread_notices: 'Lugemata teated',
        new_cases: 'Uued juhtumid',
        unanswered_cases: 'Vastamata juhtumid',
        overdue_cases: 'Üle tähtaja olevad juhtumid',
    },
    button: {
        query: 'Päring',
        editing_position: 'Redigeeri ametikohta',
        show_theme_editor: 'Näita/peida teemaredaktor',
        change_password: 'Muuda parooli',
        old_password: 'Vana parool',
        new_password: 'Uus parool',
        confirm_password: 'Kinnita parool',
        button: 'Nupp',
        about: 'Teave',
        back: 'Tagasi',
        go: 'OK',
        home: 'Avaleht',
        confirm: 'Kinnita',
        modify: 'Muuda',
        edit: 'Redigeeri',
        new: 'Uus',
        cancel: 'Tühista',
        close: 'Sulge',
        search: 'Otsi',
        reset: 'Lähtesta',
        delete: 'Kustuta',
        add: 'Lisa',
        collapse: 'Ahenda',
        expand: 'Laienda',
        download_template: 'Laadi mall alla',
        batch_import: 'Hulgiimpordi',
        import: 'Impordi',
        export: 'Ekspordi',
        export_fail: 'Import ebaõnnestus',
        detailed: 'Üksikasjad',
        details: 'Detailid',
        download: 'Laadi alla',
        toView: 'Vaata',
        toViews: 'Vaata pilte',
        uploadAttachments: 'Laadi manused üles',
        selectFile: 'Vali fail',
        fillingInstructions: 'Täitmise juhised',
        release: 'Avalda',
        release_recall: 'Tühista avaldamine',
        save: 'Salvesta',
        send: 'Saada',
        tips: 'Vihjed',
        send_back: 'Saada tagasi',
        examine: 'Vaata üle',
        void: 'Tühista',
        more: 'Rohkem',
        refresh: 'Värskenda',
        selects: 'Palun valige',
        serial_number: 'Järjenumber',
        upload_progress: 'Üleslaadimise edenemine',
        invalid: 'Kehtetu',
        daily_record: 'Päevik',
        operation_type: 'Toimingu tüüp',
        field_name: 'Välja nimi',
        edit_role: 'Redigeeri rolli',
        user_role: 'Vali roll',
        assignment_role: 'Roll',
        post: 'Ametikoht',
        sending: 'Saatmine...',
        reset_password: 'Lähtesta parool',
        display_or_not: 'Kuva või mitte',
        document: 'Dokument',
        specificTemplates: 'Kindlad mallid',
        transferOrder: 'Ümbersuuna tellimus',
        forwarding: 'Edasta',
        one_click_notification: 'Üheklõpsuline teavitus',
        english_export: 'Ekspordi inglise keeles',
        oneclick_download: 'Üheklõpsuline allalaadimine',
        passwordmsga: 'Peab sisaldama suurtähti, väiketähti, numbreid ja erimärke (@\\$!_~\\&*)',
        passwordmsgb: 'Parooli pikkus peab olema 8–16 tähemärki',
        passwordmsgc: 'Ei tohi olla sama kui kuus viimast parooli',
        export_file_list: 'Eksporditud failide loend',
        personal_center: 'Isiklik keskus',
        upload_list: 'Üleslaadimiste loend',
        clear_completed: 'Puhasta lõpetatud',
    },
    radio: {
        enabled: 'Lubatud',
        disabled: 'Keelatud',
        catalogue: 'Kataloog',
        individual: 'Üksik',
        all: 'Kõik',
        yes: 'Jah',
        no: 'Ei',
    },
    dropdown: {
        close_others: 'Sulge teised',
        close_right: 'Sulge paremal',
        close_left: 'Sulge vasakul',
    },
    table: {
        action: 'Toiming',
        explain: 'Selgitus',
        fileName: 'Faili nimi',
        size: 'Suurus (MB)',
        uploader: 'Üleslaadija',
        uploadTime: 'Üleslaadimise aeg',
        system: 'Süsteem',
        caption: 'Pealkiri',
        categorization: 'Kategoriseerimine',
        link: 'Link',
        forwarding_time: 'Edastamise aeg',
        forwarder: 'Edastaja',
        send_to: 'Saada kellele',
        mode: 'Režiim',
    },
    pagination: {
        pages: ({ named }: Parameters<MessageFunction>[0]) => `${named('number')} / Leht`,
        total: ({ named }: Parameters<MessageFunction>[0]) => `Kokku ${named('number')} kirjet`,
        vinCount: ({ named }: Parameters<MessageFunction>[0]) => `Kokku ${named('number')} autot`,
    },
    confirm: {
        confirm_deletion: 'Kinnita kustutamine?',
        confirm_void: 'Kinnita tühistamine?',
        confirm_release: 'Kinnita avaldamine?',
        ack: 'Kinnita',
        cancel: 'Tühista',
        non_records: 'Palun valige vähemalt üks kirje',
    },
    request: {
        failed_placeholder: 'Päring ebaõnnestus – serveri viga',
        success_placeholder: 'Päring õnnestus',
        auth: {
            login_success: 'Sisselogimine õnnestus',
        },
        error: {
            '404': 'Tee ei eksisteeri',
            '403': 'Ebapiisavad õigused',
        },
    },
    page: {
        global: {
            page_search: 'Lehe otsing',
        },
        error: {
            not_found: 'Lehte ei leitud',
            not_found_des: 'Siin pole midagi',
            auth_failed: 'Ebapiisavad õigused',
            auth_failed_des: 'Sellele lehele juurdepääs on keelatud',
            file_format_error: 'Vigane failivorming!',
            preview_failed: 'Eelvaade ebaõnnestus! Fail on rikutud!',
        },
        homepage: {
            homepage: homepage.homepage.etEE,
        },
        system: {
            menu: system.menu.etEE,
            dict: system.dict.etEE,
            dept: system.dept.etEE,
            role: system.role.etEE,
            user: system.user.etEE,
        },
        info: {
            announcement: Info.announcement.announcement.etEE,
            document: Info.document.document.etEE,
        },
        tech: {
            quality: {
                problemTracking: tech.quality.problemTracking.etEE,
                recallActivity: tech.quality.recallActivity.etEE,
                abnormalClaimTracking: tech.quality.abnormalClaimTracking.etEE,
            },
            management: {
                inquiryOd: tech.management.inquiry.etEE,
                permission: tech.management.permission.etEE,
                onSiteSupportHq: tech.management.onSiteSupport.etEE,
                progHistoryHq: tech.management.progHistory.etEE,
                salesRecordHq: tech.management.salesRecord.etEE,
                vehicleInfoHq: tech.management.vehicleInfo.etEE,
                claimHq: tech.management.claim.etEE,
                filterHq: tech.management.filter.etEE,
                newCarlssue: tech.management.newCarIssue.etEE,
                newCarDefinition: tech.management.newCarDefinition.etEE,
                vehicleProductionInfo: tech.management.vehicleProductionInfo.etEE,
                programmingHistoryInformationQuery:
                    tech.management.programmingHistoryInformationQuery.etEE,
                ecuControllerInformationQuery: tech.management.ecuControllerInformationQuery.etEE,
            },
        },
        components: {
            businessComponents: tech.management.businessComponents.etEE,
        },
        statistics: statistics.inquiryStatistics.etEE,
        systemClassifyA: statistics.systemClassifyA.etEE,
        systemClassifyB: statistics.systemClassifyB.etEE,
        engineerStatistics: statistics.engineerStatistics.etEE,
        defectivePart: statistics.defectivePart.etEE,
        replyInquiryStatistics: statistics.replyInquiryStatistics.etEE,
        passRateStatistics: statistics.passRateStatistics.etEE,
        timelyResponseRateStatistics: statistics.timelyResponseRateStatistics.etEE,
        responseRateStatistics24Hour: statistics.responseRateStatistics24Hour.etEE,
        customsClearance135Rate: statistics.customsClearance135Rate.etEE,
        accumulatedClosureRate: statistics.accumulatedClosureRate.etEE,
        engineerAffiliatedOrganization: statistics.engineerAffiliatedOrganization.etEE,
        EngineerResponseRateReport: statistics.EngineerResponseRateReport.etEE,
    },
    validation: {
        common: {
            required: 'See väli on kohustuslik',
            numeric: 'Peab olema täisarv',
            decimal: 'Peab olema arv',
            positive_interger: 'Peab olema positiivne täisarv',
            up_to_digits: ({ named }: Parameters<MessageFunction>[0]) =>
                `Maksimaalselt ${named('number')} numbrit`,
            more_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Ei tohi ületada ${named('number')} märki`,
            max_bytes: ({ named }: Parameters<MessageFunction>[0]) =>
                `Ületab maksimaalse lubatud märgiarvu (${named('number')})`,
            less_than_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Vähemalt ${named('number')} märki`,
            must_be_characters: ({ named }: Parameters<MessageFunction>[0]) =>
                `Peab olema täpselt ${named('number')} märki`,
            greater_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Ei tohi olla suurem kui ${named('number')}`,
            less_than: ({ named }: Parameters<MessageFunction>[0]) =>
                `Ei tohi olla väiksem kui ${named('number')}`,
            up_to_2_decimal_places: 'Maksimaalselt 2 komakohta',
            retain_up: 'Maksimaalselt 10 numbrit enne koma, kuni 2 komakohta',
            retain_ups: 'Maksimaalselt 11 numbrit enne koma, kuni 4 komakohta',
            input_number: 'Palun sisestage araabia numbreid',
            only_number_a: 'Lubatud ainult tähed või numbrid',
            translate: 'Lubatud ainult tähed',
            positive_integer: 'Täitke vähemalt üks väli',
            at_least_one: 'Täitke vähemalt üks',
        },
        tip: {
            incomplete_information: 'Teave pole täielikult täidetud',
        },
    },
    import: {
        template_file: 'Malli fail',
        browse: 'Sirvi',
        download_template: 'Laadi mall alla',
        no_file_selected: 'Faili pole valitud',
        incorrect_file_type: 'Vale failitüüp',
        exceed: 'Ületab',
        upload_success: 'Üleslaadimine õnnestus',
        upload_fail: 'Üleslaadimine ebaõnnestus',
        again_upload:
            'Üles saab laadida ainult jpg, png, bmp või gif formaadis pilte. Palun proovige uuesti.',
        attachmentUpload: 'Laadi manused üles',
        otherAttachmentUpload: 'Laadi teised manused üles',
        supportedFormats: 'Toetatud vormingud',
        preview: 'Eelvaade',
    },
    export: {
        noDataToExport: 'Eksporditavaid andmeid pole',
    },
    select: {
        all: 'Kõik',
    },
    checkbox: {
        select_all: 'Vali kõik',
    },
    dialog: {
        error_message: 'Veateade',
        one_year: 'Korraga saab ekspordida kuni ühe aasta andmeid',
    },
    ymd: {
        year: 'aasta',
        month: 'kuu',
        day: 'päev',
        week: 'nädal',
        january: 'jaanuar',
        february: 'veebruar',
        march: 'märts',
        april: 'aprill',
        may: 'mai',
        june: 'juuni',
        july: 'juuli',
        august: 'august',
        september: 'september',
        october: 'oktoober',
        november: 'november',
        december: 'detsember',
    },
};
